module.exports = __webpack_public_path__ + "static/media/newbinder-logo.58029d3b.svg";